//show/hide the overlay when hovering on/off any desktop nav item
$(document).ready(function() {

  //hide the language selector first option label
  //$('select.gt_selector.notranslate option[value=""]').remove();

  //footer logo - with social icons
  $('.block-social_media_YeVfDQ').prepend('<div class="footer-logo"><a href="https://shyanne.com/"><img src="https://d1yvdgbmeqok5q.cloudfront.net/shyanne/img/circle_white.png" alt="Shyanne" width="100" height="100"/></a></div>');
  
  if ($('#king-linked-options-section').length > 0) {
    $('.option-selector[data-option="Color"]').css('display','none');
  }

    //START - STYLES FILTER
  var stylesArray = ["1000X","100X","10X","13MWZ","15X","20X","30X","3X","4X","500X","505","50X","514","517","527","535","550","559","5X","Lace Up","6X","710","711","715","721","Lace Up","8X","936","Advanced Comfort","Affordable Fancy","Athletic","Aura","Baseball Cap","Basic Belt","Basket Weave","Bathroom Decor","Bedding","Bedroom Decor","Black Label","Blanket","Blue Label","Boot Barn Exclusive","Booties","Booty Up","Boyfriend","Branding Irons","Bronze Label","Buckle Belt","Buffalo Felt","Button Down","Cargo","Carpenter","Casual","Casual Cap","Cattleman Crease","Chelsea","Christmas","Chukka Shoe","Cold Shoulder","College","Concealed Carry","Concho","Cool Vantage","Cowboy","Cowboy Cut","Cropped","Crossbody","Crushable","Curtain","Denim","Dinnerware","Dress","Dress Hat","Drinkware","Driving Shoe","Embellished","Embroidered","Engineer Boot","Equestrian","Exotic","Fashion","Fedora","Felt","Festival","Fishing","Flannel","Flats","Frame","Fringe","Frontier","Full Size","Fur Felt","Gambler","George Strait","Glassware","Graphic","Green Label","Gun Accessory","Handmade","Hard Hat","Harness","Heels","High/Low Top","Hiking","Home Decor","Hooded","Hoodies","Hunting","Inlay","King Size","Kitchen Decor","Knee/Thigh High","Knife","Lace","Lace-Up","Lacer/Packer","Leather","Logger Boot","Long Sleeve","Maxi","Metallic","Midi","Mini","Motorcycle","Muck","Mules/Slides","Open Road","Outback","Oxfords","Palm Leaf","Patriotic","Performance","Pet Accessory","Phone Accessory","Pillow","Pinch Front Crease","Polo","Postal","Pull-On","Pumps","Queen Size","Rain","Relentless","Riata","Riding","Riding Boots","Romeo/Hog","Roper","Rubber","Service Industry","Shacket/Shirt Jacket","Sheets","Sherpa","Short Barn","Short Boots","Short Sleeve","Silver Label","Sleeveless","Slip-On","Slope Front Crease","Snaps","Snow","Softshell","Stacked Heel","Stainless","Stockman","Strapless","Straw","Sunhat","Swim","T-shirt","Tactical","Tall Boot","Tank Top","Tooled","Tooled Belt","Tote","Towel","Twin Size","Utensils","UV Protection","Vintage","Visor","Waders","Wall Decor","Wedding","Wedding Accessory","Wedge","Western Gifts","White Label","Wide Foot/Calf","Wool","Wool Felt","Work","Work Sneaker","Wrinkle Free","Wristlet","Zipper/Shoe Boot"];

  // MutationObserver is used to detect changes in the DOM
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
              // Check for added nodes with the specified class
              $(mutation.addedNodes).find('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
                  $('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, stylesArray) !== -1) {
                          $(this).closest('ul[role="list"] li').addClass('show');
                      } else {
                          $(this).closest('ul[role="list"] li').addClass('hidden');
                      }
                  });
              });

              // Check for added nodes that are the element with the specified class
               $(mutation.addedNodes).filter('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
                 $('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, stylesArray) !== -1) {
                          $(this).closest('ul[role="list"] li').addClass('show');
                      } else {
                          $(this).closest('ul[role="list"] li').addClass('hidden');
                      }
                  });
              });
          }
      });
      $('details[id="filter-filter.p.tag"] button.filter__more').trigger('click');

    if ($('details[id="filter-filter.p.tag"] ul[role="list"] li.show').length == 0) {
      $('details[id="filter-filter.p.tag"]').closest('details-disclosure').hide();
    }
    //END - STYLES FILTER
  });

  // Configure the observer to watch for changes to the element's children
  const config = { childList: true, subtree: true };

  // Start observing the document body for changes
  observer.observe(document.body, config);

  // Initial check for existing elements on page load
   $('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
     $('details[id="filter-filter.p.tag"] ul[role="list"] li').each(function() {
          var value = $(this).find('.checkbox').val();
          if ($.inArray(value, stylesArray) !== -1) {
              $(this).closest('ul[role="list"] li').addClass('show');
          } else {
              $(this).closest('ul[role="list"] li').addClass('hidden');
          }
      });
  });
  $('details[id="filter-filter.p.tag"] button.filter__more').trigger('click');
  if ($('details[id="filter-filter.p.tag"] ul[role="list"] li.show').length == 0) {
    $('details[id="filter-filter.p.tag"]').closest('details-disclosure').hide();
  }
});


//CORDIAL
// footer - email_signup
$(document).on('click','#footer-signup_form button.btn', function(){
    var email = $('#footer-signup').val().trim();
    var formValidation = true;

    var regexEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (String(email).match(regexEmail) == null ) {
      formValidation = false;
    }

    if (formValidation){
      var auth_data = {
        email: email
      }			

      var contact_data = {
        'channels': {
          'email': {
            'subscribeStatus': 'subscribed'
          }
        },
        'source_create': 'footer',   
        'signup_source': 'footer',
        'welcome_signup': true
      };

      var properties = {
        'source_create': 'footer',   
        'signup_source': 'footer',
        'welcome_signup': true
      };

      crdl([				
        ['contact', auth_data, contact_data,{'forceSubscribe': {email: true}, 'upsert': true}],
        ['event', 'email_signup', properties]
      ]);
    }
});

//register page - account_create
$('#create_customer button.btn').bind({
  click: function(){
    var firstName = $('#register-first-name').val().trim();
    var lastName = $('#register-last-name').val().trim();
    var email = $('#register-email').val().trim();
    var password = $('#register-password').val().trim();
    var formValidation = true;
    
    var regexPassword = /^.{6,}$/;
    if ( String(password).match(regexPassword) == null ) {
      formValidation = false;
    }

    if (!email || !firstName || !lastName || !password) {
      formValidation = false;
    }
    
    var loginProperties = {
      'email': email
    };
    
    if (formValidation && $('.errors').length == 0){
      var auth_data = {
        email: email
      }

      var contact_data = {
        'channels': {
            'email': {
              'subscribeStatus': 'none'
            }
        },        
        'first_name': firstName,
        'last_name': lastName,
        'source_create': 'myaccount'
      };      


      crdl([       
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'account_create'],
        ['event', 'login', loginProperties]
      ]);
    }
  }
});

//login page - login
$('#customer_login button.btn').bind({
  click: function(){
    var username = $('#customer-email').val().trim();
        
    var auth_data = {
        email: username
    }
        
    var contact_data = {
        'channels': {
            'email': {
                'address': username      
            }
        }
    };
    
    var properties = {
        "email": username
    };
        
    crdl([        
        ['contact', auth_data, contact_data],
        ['event', 'login', properties]
    ]);
  }
});

var variantPicker = document.querySelector('.variant-picker--product-available');
variantPicker.addEventListener('change', function(event) {
	setTimeout(() => {
	  	var upcValue = document.querySelector('.product-info__barcode-value').textContent;
		lcly_reload_0({ 'upc': upcValue });
     if ($('#king-linked-options-section').length > 0) {
      $('.option-selector[data-option="Color"]').css('display','none');
    }
	}, 1000);
});
